import { ListDataResponse, TableDataSource } from '@shared';
import { IIntInvoiceRegister } from '../../../../models/invoice/int-invoice-register';
import { InternationalInvApiService } from '@services';
import { catchError, finalize, of, tap } from 'rxjs';
import { IntRegistersApiService } from '../../../../services/int-registers-api/int-registers-api.service';

export class IntRegistersDatasource extends TableDataSource<IIntInvoiceRegister> {
  constructor(
    protected invoiceRegisterService: InternationalInvApiService,
    protected intRegistersApi: IntRegistersApiService,
  ) {
    super();
  }

  loadRegisters(
    pageIndex: number,
    pageSize: number,
  ): void {
    this.loading.next(true);
    this.intRegistersApi.getRegisters(pageIndex + 1, pageSize)
      .pipe(
        catchError(() => of(new ListDataResponse<IIntInvoiceRegister>())),
        finalize(() => this.loading.next(false)),
        tap((registries) => {
          this.total.next(Number(registries.total) || 0);
          this.totalInCurrentSearch.next(registries.list.length);
          this.source.next(registries.list || []);
        }),
      )
      .subscribe();
  }
}
